module.exports = __webpack_public_path__ + "img/img_01_brand_retail@3x.34c7d8f0.png";